import axios from "axios";

// Runtime-Origin verwenden statt Build-Time-Env, damit derselbe Bundle auf
// Preview (…preview.emergentagent.com) und Publish (…emergent.host) korrekt
// gegen den jeweils eigenen Backend spricht (same-origin, keine CORS-Probleme,
// keine Cookie-/SameSite-Fallen).
const BACKEND_URL =
  (typeof window !== "undefined" && window.location && window.location.origin) ||
  process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// --- Refresh-Interceptor: bei 401 versuchen wir EINMAL stillen Refresh ---
let _refreshPromise = null;

function shouldSkipRefresh(url = "") {
  // Diese Endpunkte dürfen 401 zurückgeben, ohne Refresh-Schleife auszulösen
  return (
    url.includes("/auth/refresh") ||
    url.includes("/auth/login") ||
    url.includes("/auth/register") ||
    url.includes("/auth/me") ||
    url.includes("/auth/forgot-password") ||
    url.includes("/auth/reset-password") ||
    url.includes("/demo/login")
  );
}

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config || {};
    const status = error.response?.status;
    if (status !== 401 || original._retry || shouldSkipRefresh(original.url || "")) {
      return Promise.reject(error);
    }
    original._retry = true;
    try {
      if (!_refreshPromise) {
        _refreshPromise = axios
          .post(`${API_BASE}/auth/refresh`, {}, { withCredentials: true })
          .finally(() => {
            _refreshPromise = null;
          });
      }
      await _refreshPromise;
      return api(original);
    } catch (refreshErr) {
      // Sitzung wirklich beendet — nur auf geschützten App-Pfaden zu /login leiten.
      // Öffentliche/Auth-Pfade (Reset, Notfall-Portal, Rechtsseiten) bleiben unverändert.
      if (typeof window !== "undefined") {
        const p = window.location.pathname || "";
        const PROTECTED_PREFIXES = [
          "/dashboard",
          "/lebensbaum",
          "/vault",
          "/aufgaben",
          "/notfall",   // Achtung: /notfall-zugang/* ist öffentlich – wird unten ausgenommen
          "/familie",
          "/vertrauenskarte",
          "/einstellungen",
          "/onboarding",
        ];
        const isPublicEmergency = p.startsWith("/notfall-zugang/") || p.startsWith("/karte-sperren/");
        const isProtected = !isPublicEmergency && PROTECTED_PREFIXES.some((x) => p === x || p.startsWith(x + "/"));
        if (isProtected) {
          window.location.replace("/login");
        }
      }
      return Promise.reject(refreshErr);
    }
  }
);

export function formatApiError(detail, fallback = "Etwas ist schiefgelaufen.") {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
